function createId(prefix) {
    return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`
}

function clone(value) {
    return JSON.parse(JSON.stringify(value))
}

export const V2_CONTROL_PRESETS = [
    {
        type: 'searchBar',
        pageTypes: ['HOME'],
        label: '搜索栏',
        description: '顶部搜索入口，适合首页和专题页',
        create: () => ({
            id: createId('search'),
            type: 'searchBar',
            visible: true,
            props: {
                placeholder: '搜索商品',
                linkType: 'systemPage',
                linkTarget: 'pages/search/search',
                linkName: '搜索商品'
            }
        })
    },
    {
        type: 'heroSwiper',
        pageTypes: ['HOME'],
        label: '轮播图',
        description: '大图轮播位，适合活动和推荐内容',
        create: () => ({
            id: createId('swiper'),
            type: 'heroSwiper',
            visible: true,
            props: {
                height: 360,
                items: [
                    {
                        imageUrl: '/img/mall-template-v2/simple/banner.png',
                        linkType: 'none'
                    }
                ]
            }
        })
    },
    {
        type: 'iconNav',
        pageTypes: ['HOME'],
        label: '图标导航',
        description: '常用快捷入口，支持分类和活动跳转',
        create: () => ({
            id: createId('nav'),
            type: 'iconNav',
            visible: true,
            props: {
                title: '快捷入口',
                items: [
                    {iconType: 'preset', icon: 'new', label: '新品', linkType: 'none'},
                    {iconType: 'preset', icon: 'hot', label: '热卖', linkType: 'none'},
                    {iconType: 'preset', icon: 'category', label: '分类', linkType: 'none'},
                    {iconType: 'preset', icon: 'coupon', label: '优惠', linkType: 'none'}
                ]
            }
        })
    },
    {
        type: 'sectionTitle',
        pageTypes: ['HOME'],
        label: '标题栏',
        description: '模块标题、更多入口和副标题',
        create: () => ({
            id: createId('title'),
            type: 'sectionTitle',
            visible: true,
            props: {
                title: '精选推荐',
                subtitle: 'Recommended for you',
                moreText: '更多',
                linkType: 'none'
            }
        })
    },
    {
        type: 'noticeBar',
        pageTypes: ['HOME'],
        label: '公告栏',
        description: '展示活动公告、店铺通知或促销信息',
        create: () => ({
            id: createId('notice'),
            type: 'noticeBar',
            visible: true,
            props: {
                text: '限时活动开启，满减优惠进行中',
                linkType: 'none'
            }
        })
    },
    {
        type: 'imageBanner',
        pageTypes: ['HOME'],
        label: '图片横幅',
        description: '单张横幅广告位，适合专题和活动',
        create: () => ({
            id: createId('image'),
            type: 'imageBanner',
            visible: true,
            props: {
                imageUrl: '/img/mall-template-v2/simple/preview.png',
                items: [
                    {
                        imageUrl: '/img/mall-template-v2/simple/preview.png',
                        linkType: 'none'
                    }
                ],
                columns: 1,
                radius: 16,
                gap: 8,
                aspectRatio: '16:9',
                linkType: 'none'
            }
        })
    },
    {
        type: 'couponGrid',
        pageTypes: ['HOME'],
        label: '优惠券组',
        description: '常见的领券区块，适合提升转化',
        create: () => ({
            id: createId('coupon'),
            type: 'couponGrid',
            visible: true,
            props: {
                title: '限时领券',
                mode: 'selected',
                items: []
            }
        })
    },
    {
        type: 'promotionCard',
        pageTypes: ['HOME'],
        label: '促销卡片',
        description: '用于新品首发、活动推荐和专题推广',
        create: () => ({
            id: createId('promo'),
            type: 'promotionCard',
            visible: true,
            props: {
                title: '新品首发',
                subtitle: '当季主推款式',
                buttonText: '立即查看',
                imageUrl: '/img/mall-template-v2/simple/banner.png',
                linkType: 'none'
            }
        })
    },
    {
        type: 'richText',
        pageTypes: ['HOME'],
        label: '富文本',
        description: '展示文案说明、活动规则和品牌介绍',
        create: () => ({
            id: createId('rich'),
            type: 'richText',
            visible: true,
            props: {
                title: '活动说明',
                content: '这里是活动说明文案，可用于展示品牌介绍、优惠规则或会员权益。',
                align: 'left',
                linkType: 'none'
            }
        })
    },
    {
        type: 'blankSpace',
        pageTypes: ['HOME'],
        label: '空白间距',
        description: '用于拉开模块间距和节奏',
        create: () => ({
            id: createId('space'),
            type: 'blankSpace',
            visible: true,
            props: {
                height: 24
            }
        })
    },
    {
        type: 'goodsList',
        pageTypes: ['HOME'],
        label: '商品列表',
        description: '商品瀑布流或双列卡片，适合主推商品',
        create: () => ({
            id: createId('goods'),
            type: 'goodsList',
            visible: true,
            props: {
                title: '精选商品',
                showCount: 6,
                layout: 'twoColumn'
            },
            dataSource: {
                mode: 'category',
                mock: false
            }
        })
    }
]

export function createV2PresetComponent(type) {
    const preset = V2_CONTROL_PRESETS.find(item => item.type === type)
    return preset ? clone(preset.create()) : null
}

export function cloneV2Component(component) {
    return clone(component)
}
